import { useEffect, useCallback, useState, useRef } from 'react';
import icon1 from '../images/brands/1.png';
import icon2 from '../images/brands/2.png';
import icon3 from '../images/brands/3.png';
import icon4 from '../images/brands/4.png';
import icon5 from '../images/brands/5.png';
import icon6 from '../images/brands/6.png';
// import icon7 from '../images/brands/7.png';
// import icon8 from '../images/brands/8.png';
// import icon9 from '../images/brands/9.png';
// import icon10 from '../images/brands/10.png';
import icon11 from '../images/brands/11.png';
import icon12 from '../images/brands/12.png';
import icon13 from '../images/brands/13.png';
import Marquee from "react-fast-marquee";

export const Clients = () => {
    const images = [icon1, icon2, icon3, icon4, icon5, icon6, icon11, icon12, icon13];

    return (
        <div className='clients'>
            <div className="container">
                <h3>
                    {/* From Strategy to <span className='g-green'>Spotlight</span>, */}
                    Platforms Featuring Our<span className='span1 g-green'> Clients</span>
                </h3>
            </div>
            <div className="marquee">
                <Marquee pauseOnHover={true} speed={100}>
                    {[...images, ...images].map((img, index) => (
                        <div key={index} className="slider-track">
                            <img className='icon' src={img} alt="" />
                            <div className="line"></div>
                        </div>
                    ))}
                </Marquee>
            </div>
        </div >
    )
}
